var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"header-menu"},[_c('ul',{staticClass:"header-menu-list"},_vm._l((_vm.menu),function(item,index){return _c('li',{key:index,staticClass:"list-item",on:{"click":function($event){return _vm.scrollTo(item)}}},[_c('a',{staticClass:"list-item-link",attrs:{"href":item.href}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }